/**
 * Convenient utility for comparing two values of the same type using the `<` operator.
 * @param first The first value.
 * @param second The second value.
 * @param ascending Should the sort be ascending?
 * @return 0, if equal. For ascending: 1, if first > second; otherwise, -1. The values are swapped for descending.
 */
export function compare<T>(
    first: T,
    second: T,
    ascending: boolean = true,
): number {
    if (first === second) return 0;
    const result = first < second ? -1 : 1;
    return ascending ? result : -result;
}
